import { render, staticRenderFns } from "./article-class.vue?vue&type=template&id=0d1adebc"
import script from "./article-class.vue?vue&type=script&lang=js"
export * from "./article-class.vue?vue&type=script&lang=js"
import style0 from "./article-class.vue?vue&type=style&index=0&id=0d1adebc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports